<template>
  <div>
    <div class="three-days-live-lessons">
      <div
        v-for="(item, index) in lessonList"
        :key="item.id"
        class="live-lesson-item"
      >
        <div class="left">
          <div v-if="item.liveStatus === 3" class="living-wrap">
            <img src="../../../assets/images/living.gif" alt="" />
          </div>
          <p v-else class="live-tag">直播</p>
          <div class="lesson-info">
            <p class="lesson-name">
              {{ item.lesson_name }}
            </p>
            <p class="lesson-teacher">{{ item.org_nickname }}</p>
          </div>
        </div>
        <div class="right">
          <!-- 直播间开始上课|到后台设置的课程开始时间 -->
          <button
            v-if="item.liveStatus === 3"
            @click="jumpVideoPlay(item)"
            class="operate-btn join-room-btn"
          >
            进入直播
          </button>
          <div v-else class="time-booking-wrap">
            <!-- 四小时内 -->
            <div v-if="item.inFourHours" class="four-hours">
              <p class="time">
                距
                {{ moment(item.live_start_time * 1000).format("HH:mm") }}
                直播仅剩
              </p>
              <CountDown
                class="countdown"
                :callback="() => callback(index)"
                :type="3"
                endText=""
                :endTime="item.live_start_time"
              />
            </div>
            <div v-else class="time-wrap">
              <p class="lesson-day-info" v-if="item.inTomorrow || item.isToday">
                {{ item.isToday ? "今天" : "明天" }}
              </p>
              <div v-else class="lesson-day-info">
                <p>{{ moment(item.live_start_time * 1000).format("MM.DD") }}</p>
                <p class="week-day">
                  {{ handleWeekDays(item.live_start_time) }}
                </p>
              </div>
              <p class="lesson-time">
                {{ moment(item.live_start_time * 1000).format("HH:mm") }}-{{
                  moment(item.live_end_time * 1000).format("HH:mm")
                }}
              </p>
            </div>
            <button
              v-if="item.is_booking"
              v-preventReClick
              class="operate-btn had-booking"
            >
              预约成功
            </button>
            <button
              v-preventReClick
              v-else
              @click="handleBookingLesson(item)"
              class="operate-btn join-room-btn"
            >
              立即预约
            </button>
          </div>
        </div>
      </div>
    </div>
    <BookingDialog ref="bookingDialog" />
  </div>
</template>

<script>
import BookingDialog from "../components/BookingDialog";
import { bookingLesson } from "@saas/service-api/src/course";
import moment from "moment";
import { CountDown, isHXApp } from "@saas/components/src";
import { mapGetters } from "vuex";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
export default {
  props: {
    lessonList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    assistant: {
      type: Object,
      default: () => {},
    },
    haveAssistant: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      moment,
      isHXApp: isHXApp(),
    };
  },
  components: {
    CountDown,
    BookingDialog,
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    handleWeekDays() {
      return (time) => {
        const date = new Date(time * 1000);
        const weekdays = [
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六",
        ];
        const weekday = new Date(date).getDay();
        return weekdays[weekday];
      };
    },
  },
  methods: {
    callback(index) {
      this.$set(this.lessonList, index, {
        ...this.lessonList[index],
        liveStatus: 3,
      });
    },
    jumpVideoPlay(lesson) {
      let { id, unit_id, course_id } = lesson;
      if (this.isHXApp) {
        let params = {
          course_id,
          unit_id,
          lesson_id: id,
        };
        jsToFlutter("videoPlayer", params);
      } else {
        this.$router.push(`/video-play/${course_id}/${unit_id}/${id}`);
      }
    },
    handleBookingLesson(item) {
      // 判断是否登录
      if (this.isAuthenticated) {
        let { course_id, id } = item;
        bookingLesson({
          course_id,
          lesson_id: id,
        })
          .then((res) => {
            if (res.code === 1) {
              item.is_booking = true;
              // 弹窗
              this.assistant.haveAssistant = this.haveAssistant;
              this.$refs?.bookingDialog?.openDialog(this.assistant);
            }
          })
          .catch((err) => {});
      } else {
        this.$emit("jumpLoginPage");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.three-days-live-lessons {
  --three-days-live-bg: #ffffff;
  --three-days-live-item-bg: linear-gradient(137deg, #e6fbf1 0%, #fafafa 100%);
  --three-days-live-surface-bg: #ffffff;
  --three-days-live-primary: #0d1400;
  --three-days-live-secondary: #515350;
  --three-days-live-muted: #747573;
  --three-days-live-time-bg: rgba(235, 239, 246, 0.5);
  --three-days-live-success-bg: #edfffb;

  html.dark & {
    --three-days-live-bg: var(--mg-bg-card);
    --three-days-live-item-bg: var(--mg-bg-elevated);
    --three-days-live-surface-bg: var(--mg-bg-surface);
    --three-days-live-primary: var(--mg-text-primary);
    --three-days-live-secondary: var(--mg-text-secondary);
    --three-days-live-muted: var(--mg-text-muted);
    --three-days-live-time-bg: var(--mg-control-bg);
    --three-days-live-success-bg: color-mix(
      in srgb,
      var(--mg-brand-primary) 14%,
      var(--mg-bg-surface)
    );
  }

  background: var(--three-days-live-bg);
  //   padding: 20px 0;
  padding: 24px 0 8px;
}
.live-lesson-item {
  display: flex;
  align-items: center;
  width: 768px;
  margin: 0 auto;
  height: 83px;
  background: var(--three-days-live-item-bg);
  border-radius: 24px;
  padding: 0 22px 0 16px;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
  .left {
    flex: 1;
    display: flex;
  }
  .living-wrap {
    width: 50px;
    height: 50px;
    background: var(--three-days-live-surface-bg);
    border-radius: 16px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .live-tag {
    margin-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 22px;
    border-radius: 12px;
    border: 1px solid rgba($color: #00c89d, $alpha: 0.3);
    font-weight: 500;
    font-size: 12px;
    color: #00c89d;
    line-height: 20px;
    margin-right: 12px;
    margin-top: 2px;
  }
  .lesson-info {
    flex: 1;
    width: 0;
  }
  .lesson-name {
    font-weight: 500;
    font-size: 18px;
    color: var(--three-days-live-primary);
    line-height: 25px;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .lesson-teacher {
    font-size: 14px;
    color: var(--three-days-live-secondary);
    line-height: 20px;
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 8px;
    width: 216px;
    .time-booking-wrap {
      width: 208px;
      padding: 0 12px 0 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      background: var(--three-days-live-surface-bg);
      border-radius: 12px;
    }
    .four-hours {
      .time {
        font-size: 12px;
        color: var(--three-days-live-muted);
        line-height: 17px;
        margin-bottom: 6px;
      }
    }
    .had-booking {
      background: var(--three-days-live-success-bg);
      color: #00c89d;
    }
    .operate-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 84px;
      height: 30px;
      border-radius: 23px;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
    }
    .join-room-btn {
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      color: #ffffff;
    }
    .time-wrap {
      .lesson-day-info {
        padding-left: 3px;
        display: flex;
        font-weight: 600;
        font-size: 16px;
        color: var(--three-days-live-primary);
        line-height: 22px;
        margin-bottom: 4px;
      }
      .week-day {
        margin-left: 10px;
        font-weight: 600;
        font-size: 11px;
        color: var(--three-days-live-secondary);
        line-height: 22px;
      }
      .lesson-time {
        border-radius: 8px;
        background: var(--three-days-live-time-bg);
        font-weight: 800;
        font-size: 12px;
        color: var(--three-days-live-primary);
        line-height: 24px;
        height: 24px;
        padding: 0 8px;
      }
    }
  }
}
</style>
